import React, { useState, useEffect, useRef } from 'react';
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaTimes } from 'react-icons/fa';
import axios from 'axios';
import {toast} from "react-toastify";
import AddTrainer from '../components/AddTrainer';

const Trainers = () => {
  const [trainers, setTrainers] = useState([

  ]);

  const [editingTrainer, setEditingTrainer] = useState(null);
  const modalRef = useRef();
  const [loading, setLoading] = useState(true);

  const [openTrainerModal,setOpenTrainerModal] = useState(false);

  const handleRemoveTrainer = (trainer) => {
    setEditingTrainer(trainer);
  };

  const confirmRemoval = async () => {

    try {
      const response = await axios.delete("https://klimkaara-backend-pgnq.onrender.com/trainers/delete/" + editingTrainer._id);
    } catch (error) {
      console.log(error.response.data);
    }
    setTrainers((prevTrainers) => 
      prevTrainers.filter((trainer) => trainer !== editingTrainer)
    );
    setEditingTrainer(null);
  };

  const closeModal = () => {
    setEditingTrainer(null);
  };

  // Handle Escape key press for closing modal
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  };

  const fetchTrainers = async () => {
    try {
      const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/trainers/getTrainers');
      setTrainers(response.data.trainers);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching trainers:', error);
    }
  };

  // Close modal when clicking outside
  useEffect(() => {
    fetchTrainers();
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleOpenTrainerModal = () => {
    setOpenTrainerModal(!openTrainerModal);
  }

  const [name, setName] = useState('');
  const [mobilenumber, setMobileNumber] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);

  const handleSubmit = async () => {
    console.log("Trainer details:", name, mobilenumber);
    setIsGenerating(true);
    try {
      const response = await axios.post('https://klimkaara-backend-pgnq.onrender.com/trainers/create', {
        "name" : name,
        "mobilenumber" : mobilenumber,
      });

      if (response.status === 201) {
        setIsGenerating(false);
        toast.success("Trainer added successfully");
        handleOpenTrainerModal();
        setTrainers([...trainers, response.data]);
      } else {
        throw new Error('Failed to add trainer');
      }
    } catch (error) {
      console.error('Error adding trainer:', error.response);
      setIsGenerating(false);
    }
  };

  return (
    <div className="container mx-auto p-8 min-h-screen">
     <div className='flex justify-between items-center'>
      <h1 className="text-3xl font-bold mb-6">List of Trainers</h1>
      <button className="bg-[#fded22] text-black px-4 py-2 rounded-full font-semibold hover:bg-yellow-300 transition flex items-center" onClick={handleOpenTrainerModal}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        New Trainer
      </button>
      </div>

      {/* Trainers Table */}
      {loading ? (
         <div className="flex justify-center items-center">
         <svg
                 className="animate-spin h-5 w-5 text-white mr-2"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 24 24"
               >
                 <circle
                   className="opacity-25"
                   cx="12"
                   cy="12"
                   r="10"
                   stroke="currentColor"
                   strokeWidth="4"
                 ></circle>
                 <path
                   className="opacity-75"
                   fill="currentColor"
                   d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                 ></path>
               </svg>
       </div>
      ) : trainers.length === 0 ? (
        <p className="text-center text-gray-400">No Trainers Found</p>
      ) : (
        <table className="min-w-full bg-gray-800 text-white rounded-lg shadow-lg">
          <thead>
            <tr className="text-left border-b-2 border-gray-600">
              <th className="py-2 px-4">Name</th>
              <th className="py-2 px-4">Phone Number</th>
              <th className="py-2 px-4">PT Clients Assigned</th>
              <th className="py-2 px-4"></th>
            </tr>
          </thead>
          <tbody>
            {trainers.map((trainer, index) => (
              <tr key={index} className="border-b border-gray-700">
                <td className="py-2 px-4">{trainer.name}</td>
                <td className="py-2 px-4">{trainer.mobilenumber}</td>
                <td className="py-2 px-4">{trainer.numofclients}</td>
                <td className="py-2 px-4">
                  <div className="relative inline-block text-left">
                    <button
                      onClick={() => handleRemoveTrainer(trainer)}
                      className="text-gray-400 hover:text-white"
                    >
                     <BsThreeDotsVertical />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Confirmation Modal for removing a trainer */}
      {editingTrainer && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div ref={modalRef} className="bg-gray-900 p-8 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Confirm Removal</h2>
            <p>Are you sure you want to remove {editingTrainer.name}?</p>
            <div className="flex justify-end mt-4">
              <button 
                onClick={closeModal} 
                className="mr-4 bg-red-600 text-white px-4 py-2 rounded-lg"
              >
                Cancel
              </button>
              <button 
                onClick={confirmRemoval} 
                className="bg-green-600 text-white px-4 py-2 rounded-lg"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      { openTrainerModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gray-900 rounded-lg p-8 w-full max-w-lg relative">
              <FaTimes className="absolute top-4 right-4 text-gray-500 cursor-pointer" onClick={handleOpenTrainerModal} />
              <h2 className="text-2xl font-bold mb-4 text-center">Add New Trainer</h2>
      
              <div className="space-y-4">
                <label className="block">
                  <span className="text-yellow-400">Name</span>
                  <input
                    type="text"
                    placeholder="Name"
                    required
                    className="w-full p-2 border border-gray-300 rounded mt-1 text-black"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </label>
      
                <label className="block">
                  <span className="text-yellow-400">Mobile Number</span>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    required
                    className="w-full p-2 border border-gray-300 rounded mt-1 text-black"
                    value={mobilenumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                  />
                </label>
      
                <div className="flex justify-center mt-4 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-2 px-4 rounded" onClick={handleSubmit}>
                  {isGenerating ? (
                    <button className="text-yellow-200">Loading...</button>
                  ) : (
                    <button>Add Trainer</button>
                  )}
                </div>
              </div>
            </div>
          </div> }
    </div>
  );
};

export default Trainers;

